import { render, staticRenderFns } from "./ContentStatusDetail.vue?vue&type=template&id=5e7a7646&scoped=true"
import script from "./ContentStatusDetail.vue?vue&type=script&lang=js"
export * from "./ContentStatusDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a7646",
  null
  
)

export default component.exports